/**
 * API URLs for fetch(). In development, requests go to same-origin `/api/*`
 * (proxied by src/setupProxy.js) to avoid browser CORS against the admin host.
 *
 * Production: REACT_APP_API_ORIGIN (optional) or UAT default.
 * Media (images/video): REACT_APP_MEDIA_ORIGIN (optional) or same UAT host.
 */

const DEFAULT_ORIGIN = "https://uatadmin.blueberrydmc.com";

function apiOrigin() {
  const env = process.env.REACT_APP_API_ORIGIN;
  if (env) return env.replace(/\/$/, "");
  if (process.env.NODE_ENV === "development") return "";
  return DEFAULT_ORIGIN;
}

/**
 * @param {string} path path under /api/ — e.g. "package/active/by-country/KE" or "blog/active"
 */
export function apiFetchPath(path) {
  const p = path.replace(/^\//, "");
  const o = apiOrigin();
  if (!o) return `/api/${p}`;
  return `${o}/api/${p}`;
}

/** Admin-hosted files (img/video) — not subject to fetch CORS; always absolute URL */
export function adminMediaUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(String(path))) return path;
  const rel = String(path).startsWith("/") ? path : `/${path}`;
  const mediaOrigin =
    (process.env.REACT_APP_MEDIA_ORIGIN || DEFAULT_ORIGIN).replace(/\/$/, "");
  return `${mediaOrigin}${rel}`;
}
